import { BlastSource } from './BlastSource.ts'

/**
 * One colour per taxonomy source, used wherever a source is named or plotted, so a source reads the same on
 * every page and chart. Sources shown together must stay distinguishable: Silva only co-occurs with NCBI and
 * RDP (16S), Consensus only with BOLD/NCBI/RDP, hence teal and green may sit close.
 */
export const BLAST_SOURCE_COLOR: Record<BlastSource, string> = {
  [BlastSource.Consensus]: '#16a34a',
  [BlastSource.BOLD]: '#f59e0b',
  [BlastSource.NCBI]: '#2563eb',
  [BlastSource.RDP]: '#7c3aed',
  [BlastSource.Silva]: '#0d9488'
}

/** The colour of a source given by name, case-insensitive; neutral grey for an unknown one. */
export const blastSourceColor = (source: string): string =>
  Object.entries(BLAST_SOURCE_COLOR).find(([k]) => k.toLowerCase() === source.toLowerCase())?.[1] ?? '#6b7280'

/** What kind of source it is, in a few words. RDP classifies; it is not a database hits are taken from. */
export const BLAST_SOURCE_DESCRIPTION: Record<BlastSource, string> = {
  [BlastSource.Consensus]: 'Consensus',
  [BlastSource.BOLD]: 'Reference database (BOLD Systems)',
  [BlastSource.NCBI]: 'Reference database (GenBank)',
  [BlastSource.RDP]: 'Naive Bayesian classifier',
  [BlastSource.Silva]: 'Reference database (SILVA rRNA)'
}

export const blastSourceDescription = (source: string): string =>
  Object.entries(BLAST_SOURCE_DESCRIPTION).find(([k]) => k.toLowerCase() === source.toLowerCase())?.[1] ?? source
